/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import CloudStorageFileUploader from 'shared/ui/components/uploader/CloudStorageFileUploader.vue';

const __vue_script__ = {
    name: 'KioskSettings',

    components: {
        ColorPicker,
        CloudStorageFileUploader,
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            default: () => ({})
        },

        registry: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            maxImageFileSize: 5 * Math.pow(1024, 2), // backward compatibility, not needed with the updated package
            disabled: false,

            logo: null,
            background_image: null,
            innerValue: {
                logo: false,
                background_image: false,
                background_color: null,
                primary_button_text_color: null,
                secondary_button_background_color: null,
                secondary_button_text_color: null,
                text_color: null
            }
        };
    },

    watch: {
        config: {
            immediate: true,
            handler() {
                this.innerValue.logo = this.config.logo;
                this.innerValue.background_image = this.config.background_image;
                this.innerValue.primary_font = this.config.primary_font;
                this.innerValue.secondary_font = this.config.secondary_font;
                this.innerValue.background_color = this.config.background_color;
                this.innerValue.primary_button_text_color = this.config.primary_button_text_color;
                this.innerValue.secondary_button_background_color = this.config.secondary_button_background_color;
                this.innerValue.secondary_button_text_color = this.config.secondary_button_text_color;
                this.innerValue.text_color = this.config.text_color;

                this.setAssetValue('logo', 'onsite_badge_logo');
                this.setAssetValue('background_image', 'onsite_badge_background');
            }
        }
    },


    methods: {

        /**
         * handles save button click even if form is invalid
         * @param {boolean} isFormInvalid
         */
        handleClick(isFormInvalid) {
            if (isFormInvalid) {
                this.$emit('invalid');
            }
        },

        onAssetUploaded(asset) {
            this.innerValue[asset] = true;
            this.save();
        },

        onAssetDeleted(asset) {
            this.innerValue[asset] = false;
            this.save();
        },

        save() {
            this.$emit('valid', this.innerValue);
        },

        /**
         * @param {string} innerKey the innervalue key for the asset
         * @param {string} docId the DB ID of the asset
         */
        async setAssetValue(innerKey, docId) {
            try {
                const eid = this.event._id;
                if (this.innerValue[innerKey]) {
                    this[innerKey] = await this.$services.documents.getDocById(eid, docId);
                } else {
                    this[innerKey] = null;
                }
            } catch (error) {
                console.error('[KioskSettings] Could not calculate asset path', innerKey, error);
                this.onAssetDeleted(innerKey);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
return [_c('form',{staticClass:"kiosk-settings",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.save)}}},[_c('div',{staticClass:"panels panels-a"},[_c('div',{staticClass:"panel"},[_c('cloud-storage-file-uploader',{staticClass:"logo",attrs:{"name":"logo","scope":"onsite-printing-logo","fp-type":"onsite_scanning_image","asset-id":"onsite_badge_logo","label":_vm.$t('onsite_scanning.settings.logo.label'),"hint":_vm.$t('onsite_scanning.settings.logo.hint'),"event":_vm.event,"max-size":_vm.maxImageFileSize,"disabled":_vm.disabled,"multiple":false},on:{"uploaded":function($event){return _vm.onAssetUploaded('logo')},"deleted":function($event){return _vm.onAssetDeleted('logo')}},model:{value:(_vm.logo),callback:function ($$v) {_vm.logo=$$v},expression:"logo"}})],1),_c('div',{staticClass:"panel"},[_c('cloud-storage-file-uploader',{staticClass:"background",attrs:{"name":"background","scope":"onsite-printing-background","fp-type":"onsite_scanning_image","asset-id":"onsite_badge_background","label":_vm.$t('onsite_scanning.settings.bg.label'),"hint":_vm.$t('onsite_scanning.settings.bg.hint'),"event":_vm.event,"max-size":_vm.maxImageFileSize,"disabled":_vm.disabled,"multiple":false},on:{"uploaded":function($event){return _vm.onAssetUploaded('background_image')},"deleted":function($event){return _vm.onAssetDeleted('background_image')}},model:{value:(_vm.background_image),callback:function ($$v) {_vm.background_image=$$v},expression:"background_image"}})],1)]),_c('div',{staticClass:"panels panels-a"},[_c('div',{staticClass:"panel"},[_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"background_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"background_color","label":_vm.$t('onsite_scanning.settings.background_color.label'),"tip":_vm.$t('onsite_scanning.settings.background_color.tip'),"disabled":_vm.disabled,"errors":errors},model:{value:(_vm.innerValue.background_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "background_color", $$v)},expression:"innerValue.background_color"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"primary_button_text_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"primary_button_text_color","label":_vm.$t('onsite_scanning.settings.buttons.primary_button_text_color.label'),"disabled":_vm.disabled,"errors":errors},model:{value:(_vm.innerValue.primary_button_text_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "primary_button_text_color", $$v)},expression:"innerValue.primary_button_text_color"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"secondary_button_text_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"secondary_button_text_color","label":_vm.$t('onsite_scanning.settings.buttons.secondary_button_text_color.label'),"disabled":_vm.disabled,"errors":errors},model:{value:(_vm.innerValue.secondary_button_text_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "secondary_button_text_color", $$v)},expression:"innerValue.secondary_button_text_color"}})]}}],null,true)})],1),_c('div',{staticClass:"panel"},[_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"text_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"text_color","disabled":_vm.disabled,"label":_vm.$t('onsite_scanning.settings.text_color.label'),"errors":errors},model:{value:(_vm.innerValue.text_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "text_color", $$v)},expression:"innerValue.text_color"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"secondary_button_background_color"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"secondary_button_background_color","label":_vm.$t('onsite_scanning.settings.buttons.secondary_button_background_color.label'),"tip":_vm.$t('onsite_scanning.settings.buttons.secondary_button_background_color.tip'),"disabled":_vm.disabled,"errors":errors},model:{value:(_vm.innerValue.secondary_button_background_color),callback:function ($$v) {_vm.$set(_vm.innerValue, "secondary_button_background_color", $$v)},expression:"innerValue.secondary_button_background_color"}})]}}],null,true)})],1)]),_c('div',{staticClass:"panels panel-a"}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.handleClick(invalid)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "KioskSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__